/**
 * Created by Julio Perez on 9/29/2016.
 */
//'use strict';
import * as config from '../../shared/js/visapp-config';
import d3 from 'd3';

export default class MapPageController {

    constructor(
        $state,
        $scope,
        mapTopCountriesService,
        mapLeafletService
    ) {

        let vm = this;

        vm.pageTitle = 'Map Page';
        vm.currentSection = $state.params.section = "Total Wine";
        vm.toggleSelected = $state.params.toggle = "current";
        vm.prefixYear = config.currentYear;

        vm.metricValue = getMetricValue();

        vm.mapTopCountriesService = mapTopCountriesService;
        vm.mapTopCountriesService.sectionSelected = vm.currentSection;

        vm.mapLeafletService = mapLeafletService;
        vm.mapLeafletService.init();

        let map = vm.mapLeafletService.getMap();


        let defaultStyle = {
            fillColor: "#00AED9",
            weight: 1,
            opacity: 1,
            color: '#00AED9',
            fillOpacity: 1
        };

        function stylize(feature){

            return{
                fillColor: "#00AED9",
                weight: 1,
                opacity: 1,
                color: '#00AED9',
                fillOpacity: 0.7
            }
        }


        vm.section = $state.params.section;

        vm.latlngData = vm.mapTopCountriesService.getCountryLatLng();

        vm.segmentData = vm.mapTopCountriesService.getCountrySegment(vm.currentSection);

        vm.segmentLabels = vm.mapTopCountriesService.getSegmentLabels(vm.currentSection);
        vm.currentMax = vm.mapTopCountriesService.getCurrentMax(vm.currentSection);

        vm.mapLeafletService.mapData = vm.latlngData;
        vm.mapLeafletService.segmentData = vm.segmentData;

        vm.coordinates = [];
        vm.legend = [];

        let tooltip;

        vm.mapCenter = map.getCenter();
        vm.config = {
            zoomDraw: false,
            zoomHide: true
        };

        vm.xScale = d3.scale.sqrt();
        vm.xScale.range([5, 70]);

        vm.segmentData.forEach(function (d) {
                d.val = +d[vm.metricValue];
               });

        vm.getLegendHeader=()=>{

            let header = '';

            if(vm.segmentLabels.segment){
                vm.prefixYear = config.currentYear;
                if(vm.toggleSelected.toLowerCase() === "forecast"){
                    vm.prefixYear = config.forecastYear;
                }
                header =  vm.prefixYear + vm.segmentLabels.segment + config.chartHeaderSuffix;
            }

            return header;
        }


        vm.getChartLabel=()=> {
            return config.chartLabel;
        }

        vm.getLegendUnit=()=>{
            let unit = '';

            if(vm.segmentLabels.unit)
            unit = vm.segmentLabels.unit;

            return unit;
        }

        vm.minVal = d3.min(vm.segmentData, function(d){ return d.val; });
        vm.maxVal = d3.max(vm.segmentData, function(d){ return d.val; });

        drawTooltip();
        updateLegend();
        drawLegend();


        function updateLegend(){

            vm.legend = [];
            vm.legend.push({ "range": vm.maxVal * .9 });
            vm.legend.push({ "range": vm.maxVal * .6 });
            vm.legend.push({ "range": vm.maxVal * .3 });
            vm.legend.push({ "range": vm.maxVal * .1 });
        }

        function drawLegend(){

            vm.zLevel = map.getZoom();
            vm.xScale.domain([vm.minVal, vm.maxVal]);

            if(!vm.lgd) {
                vm.lgd = d3.select("#legend")
                    .append('svg')
                    .attr({
                        'class': 'legend',
                        'width': 700,
                        'height': 85
                    });
            }

            d3.selectAll(".rect-lgd").remove();

            vm.rectLgd = vm.lgd.selectAll('.rect-lgd')
                .data(vm.legend)

            vm.rectLgd.enter()
                .append('rect')
                .transition()
                .duration(500)
                .ease("quad-in-out")
                .attr({
                    'class': '.rect-lgd',
                    'x': function(d){
                        return 75 - (getScaledValue(d.range) *.5);
                    },
                    'y': function(d){
                        return 70 - getScaledValue(d.range);
                    },
                    'width': function (d) {
                        return  getScaledValueLegend(d.range);
                    },
                    'height':  function (d) {
                        return  getScaledValueLegend(d.range);
                    },
                    'fill': function(d){
                        return "#00AED9";
                    },
                    "fill-opacity": 0,
                    "stroke": "#00AED9",
                    "stroke-width": ".5px"
                });

            d3.selectAll(".label-legend").remove();

            vm.labelLgd = vm.lgd.selectAll('.label-legend')
                .data(vm.legend);

            vm.labelLgd
                .enter()
                .append('text')
                .transition()
                .duration(500)
                .ease("quad-in-out")
                .text(function(d){
                    let numeral = require('numeral');
                    let num =  numeral(d.range).format('0a');

                    return numeral(num).format('0,0');
                })
                .attr({
                    'class': 'label-legend',
                    'x': function(){
                        return 35;
                    },
                    'y': function(d,i){
                        return i * 12 + 32;
                    }
                })
                .style({
                    // "font-size": 11,
                    "text-anchor": "middle"
                });
        }

        function isPercent(){

            if(vm.currentSection != 'Total Wine'){
                return "%";
            }else{
                return '';
            }
        }


        function drawTooltip(){

            d3.selectAll(".tooltip").remove();

            ////ADD TOOLTIP
            tooltip = d3.select("body").append("div")
                .attr({
                    "id": "tooltip",
                    "class": "tooltip"
                })
                .style("opacity", 0);

        }


        function getScaledValue(val){
                 return vm.xScale(val)/vm.zLevel;
        }

        function getScaledValueLegend(val){
            return Math.abs(vm.xScale(val)/vm.zLevel);
        }

        let geojsonLayer = new L.geoJson(vm.mapLeafletService.wMap, {
                style: stylize,
                onEachFeature: onEachFeature
        })

        function onEachFeature(feature, featureLayer){
        }

        geojsonLayer.addTo(map);

        let d3Overlay = L.d3SvgOverlay(function(selection, proj){

            vm.segmentData = vm.mapTopCountriesService.getCountrySegment(vm.currentSection);
            vm.metricValue = getMetricValue();
            vm.selection = selection;
            vm.proj = proj;
            vm.proj.layer.options = vm.config;

                vm.coordinates = [];
                vm.segmentData.forEach(function (d) {
                    let xPoint = vm.proj.latLngToLayerPoint({lat:d.latlng[0], lng:d.latlng[1]}).x;
                    let yPoint = vm.proj.latLngToLayerPoint({lat:d.latlng[0], lng:d.latlng[1]}).y;

                    d.val = +d[vm.metricValue];
                    d.xPoint = +xPoint;
                    d.yPoint = +yPoint;
                });

                vm.minVal = d3.min(vm.segmentData, function(d){ return d.val; });
                vm.maxVal = d3.max(vm.segmentData, function(d){ return d.val; });

                vm.xScale.domain([vm.minVal, vm.maxVal]);

                let bnds = [];

                vm.rects = vm.selection.selectAll('rect')
                    .data(vm.segmentData);

                vm.rects.enter()
                    .append('rect')
                    .transition()
                    .duration(500)
                    .ease("quad-in-out")
                    .attr({
                        'class': '.rect',
                        'x': function(d){
                            return d.xPoint - (getScaledValue(d.val) * .5);
                        },
                        'y': function(d){
                            return d.yPoint - (getScaledValue(d.val) * .5);
                        },
                        'width': function (d) {
                            return  getScaledValue(d.val);
                        },
                        'height':  function (d) {
                            return  getScaledValue(d.val);
                        },
                        'fill': function(d){
                            return "#00AED9";
                        },
                        "fill-opacity": .25,
                        "stroke": "#00AED9",
                        "stroke-width": .5 / vm.zLevel,
                        "cursor": "pointer"
                    });



                vm.rects.on("mouseover", function(d, i){

                    let xPos = parseFloat(d3.select(this).attr('x'));
                    let yPos = parseFloat(d3.select(this).attr('y'));
                    let ll = vm.proj.layerPointToLatLng([xPos, yPos]);

                    tooltip.transition()
                        .duration(200)
                        .style("opacity", 1);


                    tooltip.html(
                        "<div class='kpi-box'>" +
                        "<h6 class='kpi-segment'>" + vm.segmentLabels.segment + "</h6>" +
                        "<h2 class='kpi-country'>#" + (i+1) + "  " +d.country + "</h2>" +
                        "</div>" +
                        "<div class='kpi-content'>" +
                        "<h1 class='kpi thin'>" + d3.format(",.1f")(d.val) + isPercent() + "</h1>" +
                        "<h6 class='kpi-label'><small>" +
                            vm.segmentLabels.unit+ ", " +
                            vm.prefixYear +
                        "</small></h6>" +
                        "</div>"
                    )
                        .style("border", "1px solid " + d.country)
                        .style("left", (d3.event.pageX - d3.mouse(this)[0]) + getNewX(xPos, ll) + "px")
                        .style("top", (d3.event.pageY - d3.mouse(this)[1]) + getNewY(yPos, ll) + "px");



                })

                vm.rects.on("mouseout", function() {
                    tooltip.transition()
                        .duration(350)
                        .style("opacity", 0);
                });

                vm.cty = vm.segmentData.map(function (d) {
                    d.latlng = [d.latlng[0], d.latlng[1]];
                    return d;
                })

                map.on('zoomend', update);

                update();


                function getNewX(x,ll){
                    let val = 0;
                    let lng =  ll.lng;

                    if(lng > vm.mapCenter.lng){
                        val = x - 220;
                    }else{
                        val = x + 20;
                    }

                    return val;
                }

                function getNewY(y,ll){
                    let val = 0;
                    let lat = ll.lat;
                    if(lat >  vm.mapCenter.lat){
                        val = y + 10;
                    }
                    if(lat <= vm.mapCenter.lat){
                        val = y - 70;
                    }

                    return val;
                }

                function update() {

                    vm.bounds = map.getBounds();

                    map.fitBounds(vm.bounds);
                    vm.zLevel = map.getZoom();
                    map.setZoom(vm.zLevel);

                    vm.mapCenter = map.getCenter();

                    vm.segmentData.forEach(function (d) {

                        let xPoint = vm.proj.latLngToLayerPoint({lat:d.latlng[0], lng:d.latlng[1]}).x;
                        let yPoint = vm.proj.latLngToLayerPoint({lat:d.latlng[0], lng:d.latlng[1]}).y;

                        d.val = +d[vm.metricValue];
                        d.xPoint = +xPoint;
                        d.yPoint = +yPoint;

                    });

                    vm.rects
                        .transition()
                        .duration(1000)
                        .ease("quad-in-out")
                        .attr({
                            'x': function(d){
                                return d.xPoint - (getScaledValue(d.val) * .5);
                            },
                            'y': function(d){
                                return d.yPoint - (getScaledValue(d.val) * .5);
                            },
                            'width': function (d) {
                                return  getScaledValue(d.val);
                            },
                            'height':  function (d) {
                                return getScaledValue(d.val);
                            },
                            'fill': function(d){
                                return "#00AED9";
                            },
                            "fill-opacity": .5,
                            "stroke": "#00AED9",
                            "stroke-width": .75 / vm.zLevel,
                            "cursor": "pointer"
                        });

                }
            });

            d3Overlay.addTo(map);



        function getMetricValue(){

            if(vm.toggleSelected.toLowerCase() === "forecast"){
                console.log("FORE", vm.toggleSelected)
                return "metricValueForecast";
            }else{
                console.log("CURR",vm.toggleSelected)
                return "metricValueCurrent";
            }
        }

        $scope.$on('$locationChangeSuccess', function() {

            vm.currentSection = $state.params.section;
            vm.toggleSelected = $state.params.toggle;

            vm.metricValue = getMetricValue();
            vm.mapTopCountriesService.sectionSelected = vm.currentSection;
            vm.segmentData = vm.mapTopCountriesService.getCountrySegment(vm.currentSection);
            vm.segmentLabels = vm.mapTopCountriesService.getSegmentLabels(vm.currentSection);
            vm.currentMax = vm.mapTopCountriesService.getCurrentMax(vm.currentSection);

            vm.coordinates = [];

            vm.segmentData.forEach(function (d) {

                let xPoint = vm.proj.latLngToLayerPoint({lat:d.latlng[0], lng:d.latlng[1]}).x;
                let yPoint = vm.proj.latLngToLayerPoint({lat:d.latlng[0], lng:d.latlng[1]}).y;

                d.val = +d[vm.metricValue];

                d.xPoint = +xPoint;
                d.yPoint = +yPoint;

            });

            vm.cty = vm.segmentData.map(function (d) {
                d.latlng = [+d.latlng[0], +d.latlng[1]];
                return d;
            });

            vm.minVal = d3.min(vm.segmentData, function(d){ return d.val; });
            vm.maxVal = d3.max(vm.segmentData, function(d){ return d.val; });

            vm.xScale.domain([vm.minVal, vm.maxVal]);

            // map = vm.mapLeafletService.getMap();
            vm.bounds = map.getBounds();
            map.fitBounds(vm.bounds);
            vm.zLevel = map.getZoom();
            map.setZoom(vm.zLevel);

            // vm.mapCenter = map.getCenter();

            vm.rects = vm.selection.selectAll('rect')
                .data(vm.segmentData);

            vm.rects
                .transition()
                .duration(1000)
                .ease("quad-in-out")
                .attr({
                    'x': function(d){
                        return d.xPoint - (getScaledValue(d.val) * .5);
                    },
                    'y': function(d){
                        return d.yPoint - (getScaledValue(d.val) * .5);
                    },
                    'width': function (d) {
                        return  getScaledValue(d.val);
                    },
                    'height':  function (d) {
                        return getScaledValue(d.val);
                     }
                })

            updateLegend();

            vm.labelLgd = d3.selectAll('.label-legend')
                .data(vm.legend);

            vm.labelLgd
                .text(function(d){
                    let numeral = require('numeral');
                    let num =  numeral(d.range).format('0 a');
                    return numeral(num).format('0,0');
                });

        })






    }
}

MapPageController.$inject = [
    '$state',
    '$scope',
    'mapTopCountriesService',
    'mapLeafletService'
];


// WEBPACK FOOTER //
// ./src/app/views/map-page/map-page.controller.js